$(document).ready(function () {

    if (hasRedirectMarkupInLocalStorage()) {
        window.localStorage.removeItem("tutorialsRedirectMarkup");
        if (hasCourseCardContainer() && hasTutorialsList()) {
            $(".course-background")[0].scrollIntoView({ behavior: 'smooth', block: 'start' }, false);
        }
    }
});

function hasRedirectMarkupInLocalStorage() {
    return window.localStorage.getItem("tutorialsRedirectMarkup") !== null;
}

function hasTutorialsList() {
    return $(".course-background").length > 0;
}

function hasCourseCardContainer() {
    return $(".course-type-card-container").length > 0;
}
//para web capacitaciones